import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GenericDD } from "src/app/model/generic-data";
import { environment } from "src/environments/environment";
import { CustomItemSelectorModel } from "./custom-item-selector";
import * as _ from "lodash";

@Injectable({
    providedIn: 'root'
})
export class CustomItemSelectorService {


    private url: string = environment.apiUrl + '/';

    constructor(
        private http: HttpClient,
    ) {

    }

    //ITEM SELECTOR API WITH INFINITE SCROLL PAGINATION
    GenericDDWithIsc(urlString: string, offset: number, max: number, values: number[], takeValues: boolean, filter?: string): Observable<CustomItemSelectorModel[]> {
        let valArray = _.cloneDeep(values);
        valArray.push(0);
        valArray.forEach((val,index)=>{
            if(val == undefined){
                valArray.splice(index,1);
            }
        })
        console.error(valArray)
        return this.http.get<CustomItemSelectorModel[]>(`${this.url}${urlString}${urlString.includes('?') ? '&' : '?'}offset=${offset}&max=${max}&values=${valArray != undefined && valArray.length > 0 ? valArray : "empty"}&takeValues=${takeValues}${filter}`);
    }

}